/**
 * Global frontend shell behaviors shared by every page rendered through
 * <x-site.layout> (components/site/layout.blade.php): page-loader
 * completion, scroll-to-top, smooth anchor scrolling, and form focus
 * styling.
 *
 * This is the single implementation of these behaviors. They were
 * previously duplicated as an inline <script> in the layout itself and
 * again in frontend/pages/render.blade.php's @push('scripts').
 *
 * Mobile-menu behavior lives in header.js instead — the real header markup
 * uses [data-mobile-menu-toggle] / #mobile-menu, not the generic
 * [data-toggle="mobile-menu"] / [data-mobile-menu] pair this module used to
 * look for (that pair matched nothing anywhere in the codebase).
 */

function initializePageLoader() {
    window.addEventListener('load', function() {
        const preloader = document.getElementById('preloaders');
        if (preloader) {
            preloader.classList.add('loaded');
            setTimeout(() => {
                preloader.style.display = 'none';
            }, 500);
        }
    });
}

function initializeScrollToTop() {
    const scrollUpBtn = document.getElementById('scrollUpBtn');
    if (!scrollUpBtn) return;

    window.addEventListener('scroll', function() {
        if (window.pageYOffset > 100) {
            scrollUpBtn.classList.remove('opacity-0', 'translate-y-4');
            scrollUpBtn.classList.add('opacity-100', 'translate-y-0');
        } else {
            scrollUpBtn.classList.add('opacity-0', 'translate-y-4');
            scrollUpBtn.classList.remove('opacity-100', 'translate-y-0');
        }
    });

    scrollUpBtn.addEventListener('click', function() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
}

function initializeSmoothAnchorScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            // Skip if href is just '#' or empty
            if (!href || href === '#' || href.length <= 1) {
                return;
            }
            e.preventDefault();
            const target = document.querySelector(href);
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        });
    });
}

function initializeFormFocusStyling() {
    document.querySelectorAll('input, textarea, select').forEach(input => {
        input.addEventListener('focus', function() {
            this.classList.add('ring-2', 'ring-cosmic-purple', 'border-cosmic-purple');
        });

        input.addEventListener('blur', function() {
            this.classList.remove('ring-2', 'ring-cosmic-purple', 'border-cosmic-purple');
        });
    });
}

export function initializeFrontendShell() {
    initializePageLoader();
    initializeScrollToTop();
    initializeSmoothAnchorScroll();
    initializeFormFocusStyling();
}
